//TODO: GET RID OF SEQUENCE STATUS WHEN REWORKING THE DATA STRUCTURE

export function getMockedSkillsDiagnosticData(studentId) {
  return mockData[studentId];
}

export function getMockedReadingRopeData() {
  return readingRopeMockData;
}

const mockData = {
  // You can add your mocked data here if you need it
};

const readingRopeMockData = {
  readingRopeReport: {
    mastery: {
      value: 98,
      pacing: 'AHEAD_OF_GRADE_LEVEL',
      grade: null,
      month: null,
      meta: {
        srcScoreName: 'armScore',
        srcScoreValue: 5.69,
        srcActivityId: 'A1191CF4154D11F0BCCE0E57FBD5D8A1',
        srcActivityType: 'assessment',
        srcSeason: 'spring',
        srcGrade: 3
      }
    },
    threads: [
      {
        mastery: {
          value: 95,
          pacing: 'AHEAD_OF_GRADE_LEVEL',
          grade: null,
          month: null,
          meta: null
        },
        label: 'Comprehension',
        domains: [
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: 95,
              pacing: 'AHEAD_OF_GRADE_LEVEL',
              grade: null,
              month: null,
              meta: null
            },
            label: 'Background Knowledge',
            skills: [
              {
                skillId: 'WK.2.knowledge.2.spring.division',
                skillName: '2nd Grade Spring Math -- Knows about Division',
                AREA: 8.1,
                examples: null
              },
              {
                skillId: 'WK.3.knowledge.3.fall.southern',
                skillName: '3rd Grade Fall World Geography -- Knows about Southern',
                AREA: 8.4,
                examples: null
              },
              {
                skillId: 'WK.1.knowledge.1.spring.path',
                skillName: '1st Grade Spring Physics & Signal Processing -- Knows about Path',
                AREA: 7.1,
                examples: null
              }
            ]
          },
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: 95,
              pacing: 'AHEAD_OF_GRADE_LEVEL',
              grade: null,
              month: null,
              meta: null
            },
            label: 'Vocabulary',
            skills: []
          },
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: null,
              pacing: null,
              grade: null,
              month: null,
              meta: null
            },
            label: 'Structure & Reasoning',
            skills: [
              {
                skillId: 'SR.3.Structure.identify_feelings',
                skillName: 'The student demonstrates the ability to state specific character feelings.',
                AREA: 7.54,
                examples: null
              },
              {
                skillId: 'SR.3.Structure.macro.character.feelings',
                skillName: 'The student demonstrates the ability to describe characters in a story (their feelings) and explain how their actions contribute to the sequence of events',
                AREA: 7.54,
                examples: null
              },
              {
                skillId: 'SR.3.Structure.explain_impact_of_action',
                skillName: 'The student demonstrates the ability to explain how the <trait, motivation, feeling> influences the events in the story.',
                AREA: 7.54,
                examples: null
              }
            ]
          }
        ]
      },
      {
        mastery: {
          value: 90,
          pacing: 'AHEAD_OF_GRADE_LEVEL',
          grade: null,
          month: null,
          meta: null
        },
        label: 'Word Recognition',
        domains: [
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: 88,
              pacing: 'AHEAD_OF_GRADE_LEVEL',
              grade: null,
              month: null,
              meta: null
            },
            label: 'Phonological Awareness',
            skills: []
          },
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: 87,
              pacing: 'AHEAD_OF_GRADE_LEVEL',
              grade: null,
              month: null,
              meta: null
            },
            label: 'Decoding',
            skills: []
          },
          {
            __typename: 'StudentReadingRopeDomain',
            mastery: {
              value: 95,
              pacing: 'AHEAD_OF_GRADE_LEVEL',
              grade: null,
              month: null,
              meta: null
            },
            label: 'Sight Recognition',
            skills: [
              {
                skillId: 'SR.represent',
                skillName: 'Read High Frequency Words at Grade Level - represent',
                AREA: 8.7,
                examples: ['represent']
              },
              {
                skillId: 'SR.third',
                skillName: 'Read High Frequency Words at Grade Level - third',
                AREA: 8.7,
                examples: ['third']
              }
            ]
          }
        ]
      }
    ]
  }
};
